import { Typography } from '@mui/material';
import { memo } from 'react';
import { TypographyOverflow } from '../TypographyOverflow';

type Props = {
  label: string;
  description?: string;
};

/**
 * a11y-compliant override of the default MUI table header cell
 */
export const HeaderCell = memo(({ label, description }: Props) => {
  // Legitimate missing header should not be rendered
  if (!label && !description) return null;

  // Blank header with accessible description
  if (!label && description) {
    return <Typography component="span" title={description} />;
  }

  let alwaysOnTooltip: string | undefined = undefined;
  if (description && label !== description) {
    alwaysOnTooltip = description;
  }

  return (
    <TypographyOverflow component="span" fontWeight={500} alwaysOnTooltip={alwaysOnTooltip}>
      {label}
    </TypographyOverflow>
  );
});
